export default "__VITE_ASSET__BVrKRXPK__"